import { DateTimeFormatter } from '@js-joda/core';
import { useMemo } from 'react';

import { Pesel } from '@dreryk/personal-external-identifier-common-api';

import { commonTranslationKeys, createTranslatedText, TranslatableText, Translate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

type BirthDateTextViewProps = {
   readonly peselValue: string | null;
};

export const BirthDateTextView = (props: BirthDateTextViewProps): JSX.Element | null => {
   const text = useMemo<TranslatableText>(() => {
      if (!props.peselValue || !Pesel.isValid(props.peselValue)) {
         return createTranslatedText('-');
      }

      const birthDate = Pesel.of(props.peselValue).getBirthDate();
      const formattedBirthDate = birthDate.format(DateTimeFormatter.ofPattern('dd.MM.yyyy'));
      return createTranslatedText(formattedBirthDate);
   }, [props.peselValue]);

   return (
      <TextView label={commonTranslationKeys.birthDate} testId={'birthDate'}>
         <Translate>{text}</Translate>
      </TextView>
   );
};
